module.exports = __webpack_public_path__ + "../../../static/img/bs_ic_03.8aa99e1e.png";